import { requestAPI } from '../components/utilities/Utils';

export async function getMeasurementItems(token) {
    return requestAPI("_api/BrandingAdvertising/MeasurementReport/GetMeasurementItems", "GET", "", null, token, false);
}